import type { PublicApiKey } from '#packages/apilib';
import type { createPromotionsApi } from './promotionsWrapper';

export const PromotionsApiKey: PublicApiKey<typeof createPromotionsApi> = {
  name: 'PromotionsApi',
  public: true,
};
